<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case code="attestation-veracite" v-model="sasAutoInspection3.attestationVeracite" :live="liveSasAutoInspection3(15642)"> </opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasAutoInspection3() {
      return this.sas.sasAutoIP3
    }
  },

  methods: {
    liveSasAutoInspection3(cle) {
      return { endpoint: "/sas-auto-inspection-3/", cle: cle, fileId: this.sasAutoInspection3.id }
    }
  }
}
</script>

<style>
</style>